export enum LocalStorage {
  PODSCRIPT = 'podscript',
  ORG = 'automata-org',
  THEME = 'theme',
  PAUSE_REASON = 'pauseReason',
  WORKCELL_RESTART = 'workcellRestart',
}
